import React, { useEffect, useState } from 'react';
import { Card, Descriptions, Spin, message, Avatar, Button, Input, Form, Select } from 'antd';
import { UserOutlined, EditOutlined, SaveOutlined, CloseOutlined } from '@ant-design/icons';
import axios from 'axios';
import API_BASE_URL from '../../config/api';
import ThaiAddressSelector from '../../components/ThaiAddressSelector';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import getFileUrl from '../../utils/fileUrl';


const MyProfile = () => {
    const [profile, setProfile] = useState(null);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [initialValues, setInitialValue] = useState(null);
    const [passwordVisible, setPasswordVisible] = React.useState(false);

    useEffect(() => {
        fetchProfile();
    }, []);

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_BASE_URL}/api/users/me`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            const data = { ...res.data, address: { province: res.data.province, district: res.data.district, subdistrict: res.data.subdistrict } };
            //console.log('data', data);
            setInitialValue(data);
            setProfile(data);
            form.setFieldsValue(data);
        } catch (err) {
            message.error('ไม่สามารถโหลดข้อมูลโปรไฟล์');
        } finally {
            setLoading(false);
        }
    };

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            const token = localStorage.getItem('token');
            await axios.put(`${API_BASE_URL}/api/users/me`, values, {
                headers: { Authorization: `Bearer ${token}` }
            });
            message.success('บันทึกข้อมูลแล้ว');
            setEditing(false);
            fetchProfile();
        } catch (err) {
            message.error('ไม่สามารถบันทึกข้อมูล');
        }
    };

    if (loading) return <Spin />;

    return (
        <Card
            title="โปรไฟล์ของฉัน"
            extra={
                editing ? (
                    <>
                        <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} style={{ marginRight: 8 }}>
                            บันทึก
                        </Button>
                        <Button icon={<CloseOutlined />} onClick={() => setEditing(false)}>
                            ยกเลิก
                        </Button>
                    </>
                ) : (
                    <Button icon={<EditOutlined />} onClick={() => setEditing(true)}>
                        แก้ไข
                    </Button>
                )
            }
        >
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
                {profile?.photo ? (
                    <img
                        src={getFileUrl(profile.photo)}
                        alt="รูปพระ"
                        style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: '50%' }}
                    />
                ) : (
                    <Avatar size={150} icon={<UserOutlined />} />
                )}
            </div>

            {editing ? (
                <Form layout="vertical" form={form}>
                    <Form.Item label="ชื่อผู้ใช้" name="username">
                        <Input disabled />
                    </Form.Item>
                    <Form.Item label="รหัสผ่าน (ว่างไว้หากไม่ต้องการเปลี่ยนแปลง)" name="password">
                        <Input.Password
                            placeholder="ป้อนรหัสผ่านหากต้องการแก้ไข"
                            iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                        />
                    </Form.Item>
                    <Form.Item label="ชื่อ-นามสกุล" name="name" rules={[{ required: true, message: 'กรุณากรอกชื่อ' }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item label="ตำแหน่ง" name="position">
                        <Input />
                    </Form.Item>
                    <Form.Item label="เบอร์โทร" name="phone">
                        <Input />
                    </Form.Item>
                    <Form.Item name="address" label="ที่อยู่">
                        <ThaiAddressSelector disabled={true}/>
                    </Form.Item>
                </Form>
            ) : (

                <Descriptions bordered column={1}>
                    <Descriptions.Item label="ชื่อผู้ใช้">{profile.username}</Descriptions.Item>
                    <Descriptions.Item label="ชื่อ-นามสกุล">{profile.name}</Descriptions.Item>
                    <Descriptions.Item label="สิทธิ์การเข้าถึง">{profile.level}</Descriptions.Item>
                    <Descriptions.Item label="ตำแหน่ง">{profile.position}</Descriptions.Item>
                    <Descriptions.Item label="จังหวัด">{profile.address?.province}</Descriptions.Item>
                    <Descriptions.Item label="อำเภอ">{profile.address?.district}</Descriptions.Item>
                    <Descriptions.Item label="ตำบล">{profile.address?.subdistrict}</Descriptions.Item>
                    <Descriptions.Item label="เบอร์โทร">{profile.phone}</Descriptions.Item>
                </Descriptions>

            )}
        </Card >
    );
};

export default MyProfile;
